import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteRepeat } from "../../services/repeat";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useDeleteRepeat = (indicator: IIndicators) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteRepeat,
    onMutate: () => {
      indicator.setIsProcessRunning(true);
      indicator.setIsServiceError(null);
    },
    onSuccess: (status) => {
      if (status === 200) {
        queryClient.invalidateQueries({ queryKey: ["repeats"] });
        indicator.setIsProcessRunning(false);
        indicator.setIsServiceError(null);
        toast.success("Repeat deleted successfully");
      }
    },
    onError: (error: any) => {
      indicator.setIsServiceError(error?.response?.data?.message);
      indicator.setIsProcessRunning(false);
      toast.error(error?.response?.data?.message);
    },
  });
};

export default useDeleteRepeat;
